<template>
  <Container type="card-full">
    <!-- <div slot="header">
      <menu-btn :menuid="menuid" @btnClick="btnClick"></menu-btn>
    </div> -->
    <vggrid :list="list" tableheight="700" flexname="" :cols="cols" :showfooter="false" :showPage="true"
    :resizable="true" :total="query.total" @cellClick="cellClick" @pagechange="pagechange"
      :isOperate="btn.isOperate" :operateBtn="btn.right" @vggridClick="vggridClick"
    >
        <template slot="btn">
            <menu-btn :menuid="menuid" @btnClick="btnClick" @btnmenuclick="btnmenuclick"></menu-btn>
        </template>
    </vggrid>
  </Container>
</template>
<script>
  import request from  '@/utils/request'
  import MenuBtn from "../common/menuBtn"
  import vggrid from '../common/vggrid'
  import utils from '../../assets/js/utils'
  export default {
    name: 'lhcIndex',
    data () {
      return {
        menuid: this.$route.query.menuid,
        list: [],
        btn:{},
        cols: [
          { type: 'index',fieldtype: 'I', title: '行号',calculExpr:'', width: 80 },
          { field: 'lhcname', fieldtype: 'C', title: '物流码',calculExpr:'', addNewRowFlg: false},
          { field: 'lhcrscol', fieldtype: 'C', title: '收发列号',calculExpr:'',addNewRowFlg: false},
          { field: 'lhcrsflg', fieldtype: 'C', title: '对收发列影响',calculExpr:'',addNewRowFlg: false},
          { field: 'lhcscol', fieldtype: 'C',title: '结存列号',calculExpr:'',addNewRowFlg: false},
          { field: 'lhcsflg', fieldtype: 'C',title: '对结存列影响',calculExpr:'',addNewRowFlg: false},
          { field: 'lhclcscol', fieldtype: 'C',title: '分布列号',calculExpr:'',addNewRowFlg: false},
          { field: 'lhclcsflg', fieldtype: 'C',title: '对分布列影响',calculExpr:'',addNewRowFlg: false}
        ],
        lhcform: false,
        lhc: {},
        query: {
          total: 0,
          limit: 20,
          offset: 0
        }
      }
    },
    created () {
      this.$on('ADD', () => this.addLhc())
      this.$on('CHG', () => this.chgLhc())
      this.$on('DEL', () => this.delLhc())
      this.$on('CLOSE', () => this.close())
    },
    activated() {
      this.getPageList()
    },
    mounted () {
    },
    watch: {
      async '$route' () {
        this.getPageList()
      }
    },
    components: {MenuBtn,vggrid},
    methods: {
      btnClick (code) {
        this.$emit(code)
      },
      vggridClick(code,row){
        this.lhc = row
        this.$emit(code,row)
      },
      btnmenuclick(btn){
        this.btn = btn
      },
      async close() {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: ''})
      },
      async addLhc () {
        let form = {
          lhcid: 0
        }
        this.$router.push({name: 'lhcForm', params: {form: form, type: 1}})
      },
      async chgLhc () {
        this.$router.push({name: 'lhcForm', params: {form: this.lhc, type: 1}})
      },
      async delLhc () {
        console.log(this.lhc)
        this.$confirm('确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let data = await request({
            url: '/kfgl/lhc/delLhc',
            method: "post",
            data: this.lhc
          })
          if (data.issuccess===1) {
            this.getPageList()
            this.$message.success('删除成功！')
          }
        })
      },
      search (target) {},
      async save () {
        await request({
          url: '/kfgl/lhc/addOrEdit',
          method: "post",
          data: this.lhc
        })
        this.$message.success('操作成功')
        this.lhcform = false
        if (!this.lhc.lhcid) {
          this.query.currPage = 1
        }
        await this.getPageList()
      },
      async cellClick (row) {
        this.lhc = row.row
      },
      async pagechange (page) {
        this.query.offset = page.pageSize * (page.currentPage - 1)
        this.query.limit = page.pageSize
        this.getPageList()
      },
      async getPageList () {
        this.loading = true
        let res = await request({
          method: 'get',
          url: '/kfgl/lhc/getPageList',
          params: this.query
        })
        this.list = res.list
        this.query.total = res.count[0].count
        this.loading = false
      }
    },
    filters: {
    }
  }
</script>
<style lang="scss">

</style>
